export default __webpack_public_path__ + "static/media/Ataur.cc12a137.png";